<template>
  <div class="rate-table one look">
    <div class="head" id="head">
      <div class="td first-td">
        <div class="name-key">当前费率有效期</div>
      </div>
      <div class="td thd-td">
        <div class="name-key">产品名称</div>
      </div>
      <div class="td two-td">险种名称</div>
      <div class="td">方案名称</div>
      <div class="td" v-for="(item, i) in headList" :key="i">{{ item.name }}</div>
      <div class="td">首年基础费用(%)</div>
      <div class="td">首年发放费用(%)</div>
      <div class="td">首年后置费用(%)</div>
      <!-- 平台产品展示 -->
      <div class="td" v-if="((sourceType==1&&fromPage=='productManager') || (activityInfoList.length&&activityInfoList[0].mode==1))&&listBak.length==1">无门槛加费(%)</div>
      <div class="td" v-if="sourceType!=1&&fromPage!='productManager'&&!(activityInfoList.length&&activityInfoList[0].mode==1)||listBak.length!=1">
        首年限时加费(%)
        <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip" :transfer="true">
          <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" size="16" />
          <div slot="content">
            <p>约定时间内，在首年基础费用之上，每一单额外给予的费用（无保费/标保要求）。</p>
          </div>
        </Poptip>
      </div>
      <div class="td">
        首年梯度加费(%)
        <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip" :transfer="true">
          <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" size="16" />
          <div slot="content">
            <p>约定时间内，根据总保费/标保达到的不同标准，额外给予对应的费用（有保费/标保要求）。</p>
          </div>
        </Poptip>
      </div>
      <!-- 第2年及后面的,不含5年后面 -->
      <div class="td" v-for="bean in yearList" :key="'year' + bean.index" v-show="bean.index <= 5">{{ bean.text }}</div>
      <div class="td" v-if="showHead">新增基础费用</div>
      <div class="td" v-if="showHead">续年度服务津贴</div>
      <div class="td" v-if="showHead">
        继续率系数
        <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" :transfer="true">
          <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" size="16" />
          <div slot="content">
            <p>若配置此项，续期基础费用、续年度服务津贴将根据该系数将费用折算后发放。</p>
          </div>
        </Poptip>
      </div>
      <div class="td" v-if="showHead">继续率奖金率</div>
    </div>
    <div class="empty-text" v-if="!listBak || listBak.length == 0"><slot name="emptyText">暂无数据</slot></div>
    <div class="body" id="body">
      <div class="row-child top-row" v-for="(item, i) in listBak" :key="i">
        <div class="td first-td">
          <span v-if="!item.startTime && !item.endTime">长期</span>
          <span v-else>{{item.startTime || '-'}} 至 {{item.endTime || '-'}}</span>
        </div>
        <div class="td thd-td">
          <div class="product-name">
            {{ item.productName }}（{{item.productCode}}）
            <br>
            <span class="gray-tag" v-if="item.publishStatus == 1">已下架</span>
          </div>
          <div class="btn" v-if="item.commissionNum && item.commissionItems && item.sourceType == 2" @click="openBaseConfig(item)">配置基础费用</div>
          <div class="btn" v-if="isWts" @click="jumpRateHistory(item)">查看其他版本费率</div>
        </div>
        <template v-if="item.commissionNum && item.commissionItems">
          <div class="row-box">
            <div class="row-child topRow1" :id="'a' + item.productCode + item2.gradeCode" v-for="(item2, ii) in item.commissionItems" :key="ii">
              <div class="td two-td">
                <div class="productName-box">
                  <div class="tag fu" v-if="item2.isMain === '0'">附</div>
                  {{ item2.productName }}
                </div>
              </div>
              <div class="row-box">
                <div class="row-child" v-for="(item3, ii) in item2.programBaseList" :key="ii">
                  <div class="td">
                    {{ item3.name }}
                  </div>
                  <div class="td" v-for="(head, x) in headList" :key="x">
                    <tooltip :txtInfo="getKeyText(item3.factors, head.code)" v-if="getKeyText(item3.factors, head.code).length > 30"></tooltip>
                    <span v-else>{{ getKeyText(item3.factors, head.code) }}</span>
                  </div>
                  <div class="row-box">
                    <div class="row-child" v-for="(item4, iiii) in item3.organizationList" :key="iiii">
                      <!-- 首年 -->
                      <rateTableItem :list="item3.organizationList" listKey="organizationList" :item="item4" dataKey="0" :index="iiii"></rateTableItem>
                      <!-- 首年发放 -->
                      <rateTableItem
                        :list="item3.organizationList"
                        listKey="organizationList"
                        :item="item4"
                        dataKey="0"
                        :index="iiii"
                        valueKey="afterPostfRateValue"
                      ></rateTableItem>
                      <!-- 首年后置 -->
                      <rateTableItem
                        :list="item3.organizationList"
                        listKey="organizationList"
                        :item="item4"
                        dataKey="0"
                        :index="iiii"
                        valueKey="postfRateValue"
                      ></rateTableItem>
                      <!-- 平台产品加费活动 -->
                      <div class="td" v-if="((sourceType==1&&fromPage=='productManager')||(activityInfoList.length&&activityInfoList[0].mode==1)) && listBak.length==1">
                        <div class="activity-text">
                          <span v-if="item3.organizationList[0].commissionInfoBeans[0].actValue">+{{ item3.organizationList[0].commissionInfoBeans[0].actValue }}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 非平台产品首年限时加费 -->
              <activity-base v-if="(sourceType!=1&&fromPage!='productManager')&&!(activityInfoList.length&&activityInfoList[0].mode==1)||listBak.length!=1" :tableItem="item2" :topItem="item" @openModal="openModal($event.name, $event.data)"></activity-base>
              <!-- 首年梯度加费 -->
              <activity-gradient :tableItem="item2" :topItem="item" @openModal="openModal($event.name, $event.data)"></activity-gradient>
              <div class="row-box">
                <div class="row-child" v-for="(item3, ii) in item2.programBaseList" :key="ii">
                  <div class="row-box">
                    <div class="row-child" v-for="(item4, iiii) in item3.organizationList" :key="iiii">
                      <!-- 第二年及后面,不含5年后面 -->
                      <rateTableItem
                        v-show="(bean.commissionIndex != 1 && bean.commissionIndex <= 5) || !bean.commissionIndex"
                        v-for="(bean, i5) in item4.commissionInfoBeans"
                        :key="'item' + i5"
                        :list="item3.organizationList"
                        listKey="organizationList"
                        :dataKey="i5"
                        :index="iiii"
                      ></rateTableItem>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 6年及以后基础费用 -->
              <base-commission6 v-if="showHead" :tableItem="item2" :topItem="item" @openModal="openBaseConfig(item)"></base-commission6>
              <!-- 续年度服务津贴 -->
              <service-allowance v-if="showHead" :tableItem="item2" :topItem="item" @openModal="openModal($event.name, $event.data)"></service-allowance>
            </div>
          </div>
          <!-- 继续率系数 -->
          <renewal-rate-config v-if="showHead" :topItem="item" @openModal="openModal($event.name, $event.data)"></renewal-rate-config>
          <div class="row-box" v-if="showHead">
            <div class="row-child" :id="'b' + item.productCode + item2.gradeCode" v-for="(item2, ii) in item.commissionItems" :key="ii">
              <!-- 继续率奖金率 -->
              <renewal-rate-bonus :tableItem="item2" :topItem="item" @openModal="openModal($event.name, $event.data)"></renewal-rate-bonus>
            </div>
          </div>
        </template>
        <div v-else class="td full-td">
          <div class="empty-text" v-if="item.commissionNum == 0">
            <span>期数未配置，暂不能配置费用，请先</span>
            <span class="btn" @click="goPage(1, item)">配置期数</span>
          </div>
          <div class="empty-text" v-else>
            <span>基础费用未配置，暂不能配置其他费用，请先</span>
            <span class="btn" @click="openBaseConfig({...item,isEdit:1})">配置基础费用</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 首年限时加费配置 -->
    <activity-base-modal
      ref="activityModal"
      :curSupplier="curSupplier"
      @reload="$emit('reload')"
      @openModal="openModal($event.name, $event.data)"
    ></activity-base-modal>
    <!-- 首年梯度加费配置 -->
    <activity-gradient-modal
      ref="activityGradientModal"
      :curSupplier="curSupplier"
      @reload="$emit('reload')"
      @openModal="openModal($event.name, $event.data)"
    ></activity-gradient-modal>
    <!-- 续年度服务津贴 -->
    <service-allowance-modal
      ref="serviceAllowanceModal"
      :curSupplier="curSupplier"
      @reload="$emit('reload')"
      @openModal="openModal($event.name, $event.data)"
    ></service-allowance-modal>
    <!-- 继续率系数 -->
    <renewal-rate-config-modal
      ref="renewalRateConfigModal"
      :curSupplier="curSupplier"
      @reload="$emit('reload')"
      @openModal="openModal($event.name, $event.data)"
    ></renewal-rate-config-modal>
    <!-- 继续率奖金率 -->
    <renewal-rate-bonus-modal
      ref="renewalRateBonusModal"
      :curSupplier="curSupplier"
      @reload="$emit('reload')"
      @openModal="openModal($event.name, $event.data)"
    ></renewal-rate-bonus-modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import tooltip from '@/components/commons/tooltip';
import renewalRateBonus from './renewalRateBonus';
import renewalRateBonusModal from './renewalRateBonusModal';
import renewalRateConfig from './renewalRateConfig';
import renewalRateConfigModal from './renewalRateConfigModal';
import serviceAllowance from './serviceAllowance';
import serviceAllowanceModal from './serviceAllowanceModal';
import activityBase from './activityBase';
import activityBaseModal from './activityBaseModal';
import activityGradient from './activityGradient';
import activityGradientModal from './activityGradientModal';
import baseCommission6 from './baseCommission6';
import rateTableItem from '@/components/commons/feeTemplate/rateTableItem';
export default {
  mixins: [common],
  components: {
    tooltip,
    rateTableItem,
    baseCommission6,
    renewalRateConfig,
    renewalRateConfigModal,
    renewalRateBonus,
    renewalRateBonusModal,
    serviceAllowance,
    serviceAllowanceModal,
    activityBase,
    activityBaseModal,
    activityGradientModal,
    activityGradient
  },
  props: {
    curSupplier: null,
    list: null,
    sourceType: null,
    fromPage: null,
    activityInfoList: null
  },
  data() {
    return {
      showNum: 5,
      cssNum: 5,
      listBak: [],
      headList: [],
      yearList: [],
      isDynamicRate: false
    };
  },
  watch: {
    list() {
      const listBak = JSON.parse(JSON.stringify(this.list));
      const first = listBak[0];
      if (first) {
        this.headList = first.programRules;
        this.showNum = first.commissionNum; //只显示前5年
        this.isDynamicRate = first.isDynamicRate;
      } else {
        this.headList = [];
        this.isDynamicRate = true;
        this.showNum = 5;
      }
      // 处理数据
      listBak.forEach(bean => {
        bean.commissionItems &&
          bean.commissionItems.forEach(item => {
            item.hasYear6 = false;
            item.programBaseList.forEach(item2 => {
              item2.organizationList.forEach(item3 => {
                let commssionList = item3.commissionInfoBeans;
                if (commssionList && commssionList.length) {
                  commssionList = commssionList.sort((a, b) => {
                    return a.commissionIndex > b.commissionIndex ? 1 : -1;
                  });
                  item3.commissionInfoBeans6 = [];
                  if (commssionList.length < 5) {
                    // 低于5年补位
                    const addSize = 5 - commssionList.length;
                    commssionList = commssionList.concat(new Array(addSize).fill({}));
                  } else if (commssionList.length > 5) {
                    // 高于5年截取
                    item.hasYear6 = true;
                    item3.commissionInfoBeans6 = commssionList.slice(5);
                  }
                  item3.commissionInfoBeans = commssionList;
                }
              });
            });
          });
      });
      this.listBak = listBak;
      this.yearList = [];
      for (let index = 2; index <= 5; index++) {
        this.yearList.push({
          text: '第' + this.$units.numberTransform(index) + '年(%)',
          index
        });
      }
      this.$nextTick(() => {
        const arr = document.getElementsByClassName('topRow1');
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (document.getElementById(element.id.replace('a', 'b'))) {
            document.getElementById(element.id.replace('a', 'b')).style.height = element.clientHeight + 'px';
          }
        }
        document.getElementById('body').style.width = document.getElementById('head').scrollWidth + 'px';
      });
    }
  },
  computed: {
    isWts() {
      // 平台标识
      return this.curSupplier && this.curSupplier.companyId == 1;
    },
    showHead() {
      // 桐心保或梧桐树隐藏续期相关表头
      if (this.curSupplier && (this.curSupplier.companyId == 1 || this.curSupplier.companyId == 2)) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    openModal(name, e) {
      if (name == 'baseCommissionModal') {
        this.openBaseConfig(e)
      } else {
        this.$refs[name].open(e);
      }
    },
    // 跳转到费率历史
    jumpRateHistory(item) {
      if(!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      const data = {
        productCode: item.productCode,
        productName: item.productName,
        companyName: item.companyName,
        supplierName: this.curSupplier.companyName,
        backUrl: this.delQueStr(this.$route.fullPath, 'time'),
      };
      this.openPageTabTags('/productResource/feeUpstreamCofnig/rateHistoryList' ,data)
    },
    // 打开基础费用
    openBaseConfig(item) {
      const data = {
        id: item.productId,
        code: item.productCode,
        name: item.productName,
        productCategory: item.productCategory,
        companyName: item.companyName,
        supplierName: this.curSupplier.companyName,
        backUrl: '/productResource/feeUpstreamCofnig',
        sourceType: item.sourceType,
        isEdit:item.isEdit,
        timeStr: new Date().getTime()
      };
      this.$router.push({
        path: '/productResource/productManager/productManageCommission',
        query: data
      });
    },
    // 获取方案文本
    getKeyText(list, code) {
      const data = list.find(item => {
        return item.roleCode == code;
      });
      if (data && data.remark) {
        return data.remark;
      } else {
        return '-';
      }
    },
    /**
     * type 跳转页面类型 1产品编辑 2产品方案配置
     * data 当前数据
     */
    goPage(type, data) {
      if (data.sourceType != 2) {
        this.$notice.msg('平台产品不可配置，请联系您的销售支持');
        return;
      }
      if (type == 2) {
      } else {
        this.openPageTabTags('/productResource/productManager/productEdit', {
          id: data.productId,
          code: data.productCode,
          backUrl: '/productResource/feeUpstreamCofnig',
          tab: type,
          timeStr: new Date().getTime()
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './rateTable.scss';
</style>